import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  accountQuery,
  buildCasinoGameFilters,
  casinoGamesQuery,
  useAuthSession,
} from '@/api';
import { cn } from '@/lib/cn';
import { GameCarousel } from '@/ui/casino/GameCarousel';
import { useCasinoFavorites } from '@/ui/casino/useCasinoFavorites';

export interface HomePopularGamesProps {
  className?: string;
}

/**
 * Figma CasinoGameSection Popular Games — hot/popular slots rail on the homepage.
 */
export function HomePopularGames({ className }: HomePopularGamesProps) {
  const { user } = useAuthSession();
  const { data: account } = useQuery(accountQuery());
  const { showFavorite, toggleFavorite } = useCasinoFavorites();

  const filters = useMemo(
    () => buildCasinoGameFilters({ account, user, popular: true, category: 'slots' }),
    [account, user],
  );
  const gamesQuery = useQuery(casinoGamesQuery(filters));

  return (
    <GameCarousel
      title="Popular Games"
      icon="populargames"
      seeAllTo="/casino/hot"
      games={gamesQuery.data?.Data ?? []}
      isLoading={gamesQuery.isLoading}
      showFavorite={showFavorite}
      onToggleFavorite={toggleFavorite}
      className={cn(className)}
    />
  );
}
